//--------------- IMPORTAÇÕES ---------------//
import api from "../../../shared/services/api";
import { toast } from "react-toastify";


//--------------- FUNÇÃO ASSÍNCRONA SALVAR EMPRESA ---------------//
// Responsável por salvar a empresa criada via API
export default async function createProductService(formData) {
  try {
    const temId = [formData.id_produto_hotmart, formData.id_produto_kiwify, formData.id_produto_lastlink].some(v => v && String(v).trim());
    if (!formData.nome || !temId) {
        toast.warn("Informe o nome e o ID do produto em pelo menos uma plataforma");
        return false;
}
    const r = await api.post("/produtos", formData);
    toast.success("Produto criado com sucesso");
    return r.data || true;
  } catch (error) {
    toast.error(error?.response?.data?.error || "Erro ao criar produto");
    return false;
  }
}